export const INITIAL_STATE={isTpSl:false,tpOrderPrice:null,slOrderPrice:null};